import React from "react";
import { Radio } from "antd";
import { FormattedMessage } from "react-intl";

const PaymentRadioState = ({isReconciliationForm, requestBody, setRequestBody}) => {
  
  return !requestBody.scope || isReconciliationForm || (requestBody.scope === "fiscal_social_security" &&
  requestBody.status.confirmed === false) ? null : 
    (
      <Radio.Group
        onChange={ val => {          
          setRequestBody({
            ...requestBody,
            type: ["rent", "financing", "recurring_fees"].includes(requestBody.scope) && (val === 1 || val===3) ? 
              "supplier" : 
              ["rent", "financing", "recurring_fees"].includes(requestBody.scope) && (val === 2 || val===4) ? 
                "customer" : requestBody.type,
            payment: {
              ...requestBody.payment,
              status:
                val.target.value === 1 || val.target.value === 2 ? "due" : "paid",
              type:
                val.target.value === 2 || val.target.value === 4 ? "item_collect" : requestBody.payment.type !== "item_collect" ? requestBody.payment.type : ""
            }
          });
        }}
        /*
      onChange={val => {
        setDueOrCollect(val.target.value === 1 || val.target.value === 3
          ? "due"
          : "collect");
        onTotalTypeChange(val);
      }}
      */
        value={
          requestBody.payment.status === "paid" && requestBody.payment.type === "item_collect" ?
            4 :
            requestBody.payment.status === "paid" && requestBody.payment.type !== "item_collect" ?
              3 :
              requestBody.payment.status === "due" && requestBody.payment.type === "item_collect" ?
                2 : 
                requestBody.payment.status === "due" && requestBody.payment.type !== "item_collect" ?
                  1 :
                  null        
        }
        style={{
          marginTop: 32,
          maxWidth: 300,
          display: "flex"
        /* (requestBody.totalAmount && requestBody.totalAmount !== 0) ||
              (requestBody.scope === "fiscal_social_security" &&
                requestBody.status.confirmed === true)
              ? "flex"
              : "none"*/
        }}
      >
        <div style={{ width: "50%" }}>
          <Radio
            style={{ paddingBottom: 12 }}
            value={1}
            disabled={requestBody.scope === "credit"}
          >
            <FormattedMessage id="deadlines.pages.table.due" />
          </Radio>
          <Radio
            style={{ paddingBottom: 12 }}
            value={3}
            disabled={requestBody.scope === "credit"}
          >
            <FormattedMessage id="deadlines.paid" />
          </Radio>
        </div>
        <div style={{ width: "50%" }}>
          <Radio
            style={{ paddingBottom: 12 }}
            value={2}
            disabled={
              requestBody.scope === "fiscal_social_security" ||
              requestBody.scope === "debt"
            }
          >
            <FormattedMessage id="deadlines.pages.table.toCash" />
          </Radio>
          <Radio
            style={{ paddingBottom: 12 }}
            value={4}
            disabled={
              requestBody.scope === "fiscal_social_security" ||
              requestBody.scope === "debt"
            }
          >
            <FormattedMessage id="deadlines.collected" />
          </Radio>
        </div>
      </Radio.Group>

    );
};

export default PaymentRadioState;